import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import Swal from 'sweetalert2'

@Component({
	selector: 'files',
	templateUrl: './files.component.html',
	styleUrls: ['./files.component.scss']
})

export class FilesComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input() courseID = 0
	@Input() parentType: 'lesson' | 'heading' = 'heading'
	@Input() parentID = 0
	@Input() dialog = false
	lessonID = 0
	// @Input() lessonID = 0
	// @Input() unitID = 0

	loading = true
	error = false
	hasFiles = false
	clipboard: Clipboard | undefined

	files: any[] = []
	acceptedTypes = [
		'application/msword', // doc
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
		'application/vnd.oasis.opendocument.text', // odt
		'application/vnd.ms-excel', // xls
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
		'application/vnd.oasis.opendocument.spreadsheet', // ods
		'application/vnd.ms-powerpoint', // ppt / pps
		'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
		'application/vnd.openxmlformats-officedocument.presentationml.slideshow', // ppsx
		'application/vnd.oasis.opendocument.presentation', // odp
		'application/pdf', // pdf
		'application/x-zip-compressed', // zip
	]
	acceptedTypesStr = 'doc, docx, odt, xls, xlsx, ods, ppt, pps, pptx, ppsx, odp, pdf, zip'
	
	upload = false
	filesToUpload: any[] = []
	uploading = false
	uploadError = false
	uploadSuccess = false

	getLessonFilesSub = new Subscription
	fileUploadSub = new Subscription
	editFileSub = new Subscription
	deleteFileSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService) {}

	ngOnInit(): void {
		this.clipboard = navigator.clipboard
	}

	ngAfterViewInit(): void {}

	ngOnChanges(): void {
		if (this.parentType == 'lesson') {
			this.lessonID = this.parentID
			this.getLessonFiles(this.lessonID)
		}
	}

	ngOnDestroy(): void {
		this.getLessonFilesSub?.unsubscribe()
		this.fileUploadSub?.unsubscribe()
		this.editFileSub?.unsubscribe()
		this.deleteFileSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	getLessonFiles(lesson: number) {
		this.loading = true
		this.getLessonFilesSub = this.dataService.getLessonFiles(lesson)
		.subscribe(
			data => {
				console.log(data)
				this.loading = false
				this.files = data
				this.hasFiles = data.length > 0
			},
			_error => {
				// console.log(error)
			},
		)
	}

	addFileToList(event: Event) {
		let input = event.currentTarget as HTMLInputElement
		let files: any = input.files
		// console.log(input)
		// console.log(files)

		let filesSkipped = false
		for (let f = 0; f < files.length; f++) {
			let file = files.item(f)
			console.log(file)
			let fileType = file.type
			file.sizeMB = (file.size / 1048576).toFixed(2)
			if (file.size >= 33554432) {
				filesSkipped = true
				continue
			}

			if (!this.acceptedTypes.includes(fileType)) {
				let alert_msg = ''
				if (fileType.includes('image') || fileType.includes('video')) 
					alert_msg = 'Este archivo es un archivo multimedia. Por favor, subir mediante Multimedia.'
				else 
					alert_msg = 'Tipo de archivo no soportado.'
		
				Swal.fire('Error', alert_msg, 'error')
				input.value = ''
				return
			}
	
			if (this.filesToUpload.includes(file)) {
				Swal.fire('Error', 'Ya se ha subido este archivo.', 'error')
			} else {
				this.filesToUpload.push(file)
			}
		}

		input.value = ''
		if (filesSkipped) {
			Swal.fire('Cuidado', 'Uno o más archivos pesan más de 32 MB, no se añadirán a la lista.', 'warning')
		}
	}

	removeFileFromList(file: File) {
		let list = this.filesToUpload
		list?.splice(list.indexOf(file), 1)
	}

	uploadFiles() {
		this.uploading = true
		this.uploadError = false
		this.uploadSuccess = false

		this.filesToUpload.forEach((file) => {
			// console.log(this.lessonID)
			// console.log(file)
			this.fileUploadSub = this.dataService.uploadLessonFile(this.lessonID, file)
			.subscribe(
				_data => {
					// console.log(data)

					this.uploading = false
					this.uploadError = false
					this.uploadSuccess = true
				},
				_error => {
					// console.log(error)

					this.uploading = false
					this.uploadError = true
					this.uploadSuccess = false
				}
			)
		})
	}

	editFileDesc(file: any) {
		// console.log(file)
		let id = file.id
		let desc = file.description
		console.log(desc)

		this.editFileSub = this.dataService.editFile(id, desc)
		.subscribe(
			_data => {
				// console.log(data)
				file.descSaved = true
				setTimeout(() => {
					file.descSaved = false
				}, 1500)
			},
			_error => {
				// console.log(error)
			},
		)
		
		return false
	}

	copyFileRef(file: any) {
		if (!this.clipboard) return false

		navigator.clipboard.writeText(file.ref)
		file.refCopied = true
		setTimeout(() => {
			file.refCopied = false
		}, 1500)

		return false
	}

	deleteFile(file: any) {
		let id = file.id
		let lesson = file.lesson

		Swal.fire({
			title: '¿Seguro?',
			text: '¿Está seguro que desea eliminar este archivo?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Aceptar',
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return

			this.deleteFileSub = this.dataService.deleteFile(id)
			.subscribe(
				_data => {
					// console.log(data)
					this.getLessonFiles(lesson)
				},
				_error => {
					// console.log(error)
				},
			)
		})

		return false
	}

}
